module.exports = __webpack_public_path__ + "media/images/xpass/rewards-loader-45e84bcf37f639c087321354b68f02a6.svg";